export { AddPaymentMethod } from './add-payment-method.component';
